import classNames from 'clsx';
import React from 'react';

import ChestsImage from '../../assets/images/chests.png';

import styles from './ChestIcon.scss';

interface Props {
  tier: number;
  showBackground?: boolean;
  style?: React.CSSProperties;
}

const ChestIcon: React.FC<Props> = (props) => (
  <div className={classNames({ [styles.iconContainer]: props.showBackground })}>
    <div
      className={styles.chestIcon}
      style={{
        background: `url(${ChestsImage}) no-repeat`,
        backgroundPosition: `0 -${(props.tier - 1) * 70}px`,
        ...props.style
      }}
    />
  </div>
);

export default ChestIcon;
